import { Row } from "antd";
import styled from "styled-components";

export const HeaderContainer = styled(Row)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
